import { ResponseDTO } from './response-dto';
import { UserHistoryRowDTO } from './user-history-row-dto';

export interface ReadUserHistoryResponseDTO extends ResponseDTO {
    userHistory?: UserHistoryRowDTO[];
}
